import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { setCurrentTabAsDirty, updateCommunication } from '../../../../store/details/rim/actions';

import { Checkbox } from '@mui/material';
import { CommunicationRequest as CommunicationType } from '../../../../business/models/dto/rim/communication.request.dto';
import { DaccaCalculation } from '../../../../store/details/dacca/types';
import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './rim.module.css';
import { validateEmail } from '../../../../store/shared/actions';
import { Company, Role } from '../../../../store/shared/model';

interface PropsFromState {
  readonly communication: CommunicationType;
  readonly locked: boolean;
  readonly emailEnteredButNotCheckedWarning: boolean;
  readonly daccaCalculations: DaccaCalculation[];
  readonly isBelfiusParentCompany: boolean;
}

interface PropsFromDispatch {
  readonly updateValues: typeof updateCommunication;
  readonly setCurrentTabAsDirty: typeof setCurrentTabAsDirty;
  readonly validateEmail: typeof validateEmail;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class Communication extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <div>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  disabled={this.props.locked}
                  checked={this.props.communication.sendEmailToPolicyHolder}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.communication, sendEmailToPolicyHolder: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
                {this.localization.get('details.rim.communication.sendEmailToPolicyHolder')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.communication.emailPolicyHolder')}
                value={this.props.communication.emailPolicyHolder ? this.props.communication.emailPolicyHolder : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.communication, emailPolicyHolder: event.target.value });
                  this.props.setCurrentTabAsDirty();
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.validateEmail(event.target.value);
                }} />
              {this.props.isBelfiusParentCompany ?
              <div className={styles.checkboxDacca}>
                <Checkbox
                  disabled={this.props.locked || !this.props.communication.sendEmailToPolicyHolder}
                  checked={this.props.communication.sendDaccaEmailToPolicyHolder}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.communication, sendDaccaEmailToPolicyHolder: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
                <img alt="" className={styles.daccaIcon} src={require('../../../../assets/images/dacca_with_calculation_85x85.png')} />
              </div> : ''}
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  disabled={this.props.locked}
                  checked={this.props.communication.sendEmailToCounterExpert}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.communication, sendEmailToCounterExpert: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
                {this.localization.get('details.rim.communication.sendEmailToCounterExpert')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.communication.emailCounterExpert')}
                value={this.props.communication.emailCounterExpert ? this.props.communication.emailCounterExpert : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.communication, emailCounterExpert: event.target.value });
                  this.props.setCurrentTabAsDirty();
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.validateEmail(event.target.value);
                }} />
              {this.props.isBelfiusParentCompany ?
              <div className={styles.checkboxDacca}>
                <Checkbox
                  disabled={this.props.locked || !this.props.communication.sendEmailToCounterExpert}
                  checked={this.props.communication.sendDaccaEmailToCounterExpert}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.communication, sendDaccaEmailToCounterExpert: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
                <img alt="" className={styles.daccaIcon} src={require('../../../../assets/images/dacca_with_calculation_85x85.png')} />
              </div> : ''}
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  disabled={this.props.locked}
                  checked={this.props.communication.sendEmailToPersonalExpert}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.communication, sendEmailToPersonalExpert: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
                {this.localization.get('details.rim.communication.sendEmailToPersonalExpert')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.communication.emailPersonalExpert')}
                value={this.props.communication.emailPersonalExpert ? this.props.communication.emailPersonalExpert : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.communication, emailPersonalExpert: event.target.value });
                  this.props.setCurrentTabAsDirty();
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.validateEmail(event.target.value);
                }} />
              {this.props.isBelfiusParentCompany ?
              <div className={styles.checkboxDacca}>
                <Checkbox
                  disabled={this.props.locked || !this.props.communication.sendEmailToPersonalExpert}
                  checked={this.props.communication.sendDaccaEmailToPersonalExpert}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.communication, sendDaccaEmailToPersonalExpert: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
                <img alt="" className={styles.daccaIcon} src={require('../../../../assets/images/dacca_with_calculation_85x85.png')} />
              </div> : '' }
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  disabled={this.props.locked}
                  checked={this.props.communication.sendEmailToOther}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.communication, sendEmailToOther: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
                {this.localization.get('details.rim.communication.sendEmailToOther')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.communication.emailOther')}
                value={this.props.communication.emailOther ? this.props.communication.emailOther : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.communication, emailOther: event.target.value });
                  this.props.setCurrentTabAsDirty();
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.validateEmail(event.target.value);
                }} />
              {this.props.isBelfiusParentCompany ?
              <div className={styles.checkboxDacca}>
                <Checkbox
                  disabled={this.props.locked || !this.props.communication.sendEmailToOther}
                  checked={this.props.communication.sendDaccaEmailToOther}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.communication, sendDaccaEmailToOther: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
                <img alt="" className={styles.daccaIcon} src={require('../../../../assets/images/dacca_with_calculation_85x85.png')} />
              </div> : ''}
            </div>
          </div>
          {!this.props.locked && this.props.emailEnteredButNotCheckedWarning &&
            <div className={`${styles.row} ${styles.warning}`}>
              {this.localization.get('details.rim.communication.emailHasValueButNotChecked')}
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsRim, detailsDacca }, caseState: { selectedCase }, shared }: ApplicationState): PropsFromState => ({
  communication: detailsRim.communication,
  locked: !!detailsRim.communication.sent || !!selectedCase.blocked || !((shared.roles || []).includes(Role.ExFiLoAd)),
  emailEnteredButNotCheckedWarning:
    (!detailsRim.communication.sendEmailToPolicyHolder && (detailsRim.communication.emailPolicyHolder || '').trim() !== '') ||
    (!detailsRim.communication.sendEmailToCounterExpert && (detailsRim.communication.emailCounterExpert || '').trim() !== '') ||
    (!detailsRim.communication.sendEmailToPersonalExpert && (detailsRim.communication.emailPersonalExpert || '').trim() !== '') ||
    (!detailsRim.communication.sendEmailToOther && (detailsRim.communication.emailOther || '').trim() !== ''),
  daccaCalculations: detailsDacca?.daccaCalculations || null, // Ensure fallback if undefined
  isBelfiusParentCompany: shared.parentPartyDibCode === Company.Belfius,
});


const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateValues: (counterExpertise: CommunicationType) => dispatch(updateCommunication(counterExpertise)),
  setCurrentTabAsDirty: () => dispatch(setCurrentTabAsDirty()),
  validateEmail: (email: string) => dispatch(validateEmail(email))
});

export default connect(mapStateToProps, mapDispatchToProps)(Communication);
